export default "__VITE_ASSET__BfsKX05Q__"